// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__13zvo","productName":"Table_productName__iNcFq"};